// extracted by mini-css-extract-plugin
module.exports = {"bendingTable":"BendingRadiusToThicknessTable_bendingTable__1YO-D"};